import type { Template } from "@/types";

export const PO_02_H2_V0: Template[] = [
{
    id: "po-02-h2v0-01",
    name: "PO 01 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 216, width: 605, height: 419, rotation: 0, imageRotation: 0 },
            { id: "2", x: 612, y: 216, width: 605, height: 419, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-02",
    name: "PO 02 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 44, y: 246, width: 523, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 652, y: 246, width: 523, height: 362, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-03",
    name: "PO 03 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 73, y: 246, width: 533, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 612, y: 246, width: 533, height: 362, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-04",
    name: "PO 04 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 39, y: 246, width: 533, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 713, y: 290, width: 397, height: 269, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-05",
    name: "PO 05 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 106, y: 290, width: 397, height: 269, rotation: 0, imageRotation: 0 },
            { id: "2", x: 645, y: 246, width: 533, height: 362, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-06",
    name: "PO 06 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 44, y: 443, width: 523, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 652, y: 443, width: 523, height: 362, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-07",
    name: "PO 07 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 713, y: 290, width: 397, height: 269, rotation: 0, imageRotation: 0 },
            { id: "2", x: 105, y: 290, width: 397, height: 269, rotation: 0, imageRotation: 0 }
    ],
}
];